import React from 'react';
import image from '../images/image4.png';
import { TourGuideImage } from '../TourGuideImage';

export const Segment8 = () => (
    <div>
        <TourGuideImage src={image} footnote={"Civil Twilight, Anya Schiller"} />
    </div>
);
